import { takeLatest, all } from 'redux-saga/effects';
import apiSaga from 'legacy-src/shared/util/apiSagaGenerator';
import {
  doImpersonate,
  logoutImpersonate,
  refreshImpersonatorAccessToken,
} from './actions';

function* impersonateSaga({ payload = {} }) {
  yield apiSaga(doImpersonate, {
    method: 'post',
    url: `${FYM_ACCOUNTS_URL}/impersonate/`,
    data: payload.params,
    headers: payload.headers,
    onReady: payload.onReady,
  });
}

function* logoutImpersonateSaga({ payload = {} }) {
  yield apiSaga(logoutImpersonate, {
    method: 'post',
    url: `${FYM_ACCOUNTS_URL}/auth/logout/`,
    data: payload.params,
    headers: payload.headers,
    onReady: payload.onReady,
  });
}

function* refreshImpersonatorAccessTokenSaga({ payload = {} }) {
  yield apiSaga(refreshImpersonatorAccessToken, {
    method: 'post',
    url: `${FYM_ACCOUNTS_URL}/token/refresh/`,
    data: payload.params,
    headers: payload.headers,
    onReady: payload.onReady,
  });
}

/**
 * Impersonate Saga
 * @yield {Saga} All sagas that belong to impersonate.
 */
export default function* teacherImpersonateSaga() {
  yield all([
    takeLatest(doImpersonate.TRIGGER, impersonateSaga),
    takeLatest(logoutImpersonate.TRIGGER, logoutImpersonateSaga),
    takeLatest(
      refreshImpersonatorAccessToken.TRIGGER,
      refreshImpersonatorAccessTokenSaga,
    ),
  ]);
}
